module.exports = __webpack_public_path__ + "img/SouthbridgeLogo.9f90011e.png";